type FlowType = 'consume' | 'retire';

interface ProgressData {
    completedStep: number;
    // answers는 선택 사항. 필요한 경우 확장해 사용
    answers?: Record<string, unknown>;
}

const getStorageKey = (flow: FlowType, userKey: string) => `saa:${flow}:progress:${userKey}`;

const getStableAnonId = (): string => {
    const key = 'saa-hashId';
    if (typeof window === 'undefined') return 'server';
    try {
        const existing = localStorage.getItem(key);
        if (existing) return existing as string;
        const generated = (typeof crypto !== 'undefined' && 'randomUUID' in crypto)
            ? (crypto as any).randomUUID()
            : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        localStorage.setItem(key, generated);
        return generated;
    } catch {
        return 'fallback';
    }
};

export const resolveUserKey = (_email?: string | null): string => {
    if (typeof window !== 'undefined') return `uid:${getStableAnonId()}`;
    return 'uid:server';
};

export const readProgress = (flow: FlowType, userKey: string): ProgressData | null => {
    if (typeof window === 'undefined') return null;
    try {
        const raw = sessionStorage.getItem(getStorageKey(flow, userKey));
        if (!raw) return null;
        return JSON.parse(raw) as ProgressData;
    } catch {
        return null;
    }
};

export const writeProgress = (flow: FlowType, userKey: string, data: ProgressData) => {
    if (typeof window === 'undefined') return;
    try {
        const prevRaw = sessionStorage.getItem(getStorageKey(flow, userKey));
        const prev: ProgressData = prevRaw ? JSON.parse(prevRaw) : { completedStep: 0 };
        const merged: ProgressData = {
            completedStep: Math.max(prev?.completedStep ?? 0, data?.completedStep ?? 0),
            answers: {
                ...(prev?.answers || {}),
                ...(data?.answers || {}),
            },
        };
        sessionStorage.setItem(getStorageKey(flow, userKey), JSON.stringify(merged));
    } catch {
        // ignore quota or serialization errors
    }
};

export const clearProgress = (flow: FlowType, userKey: string) => {
    if (typeof window === 'undefined') return;
    try {
        sessionStorage.removeItem(getStorageKey(flow, userKey));
    } catch {
        // ignore
    }
};

// 요청된 step이 유효한지 검증. 유효하지 않으면 1스텝으로 이동
export const ensureStepGuard = (
    flow: FlowType,
    userKey: string,
    requestedStep: number,
    gotoStep: (s: number) => void,
) => {
    if (requestedStep <= 1) return;
    const prog = readProgress(flow, userKey);
    if (!prog || typeof prog.completedStep !== 'number') {
        gotoStep(1);
        return;
    }
    if (prog.completedStep < requestedStep - 1) {
        gotoStep(1);
    }
};


